import React, { memo } from 'react';

import { LoadingSkeleton } from '@/components/SkeletonLoader';
import { Box } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { designSystem } from '@/styles/styles';

export const CasinoLayoutSkeleton = memo(() => {
    const skeletonItems = Array.from({ length: 5 }, (_, index) => index);

    return (
        <Box p="s16">
            {skeletonItems.map(item => (
                <Box key={item} mt="s16" mb="s22" flex={1}>
                    <Box borderRadius="r12" backgroundColor={ds.colorToken.background.neutral.subtler}>
                        <LoadingSkeleton
                            skeletonColor={designSystem.colors.neutral300}
                            height={28}
                            borderRadius="r12"
                        />
                    </Box>
                    <Box height={16} />
                    <Box borderRadius="r20" backgroundColor={ds.colorToken.background.neutral.subtler}>
                        <LoadingSkeleton
                            skeletonColor={designSystem.colors.neutral300}
                            height={115}
                            borderRadius="r20"
                        />
                    </Box>
                </Box>
            ))}
        </Box>
    );
});
